import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

const shortenId = (id) => {
  const value = String(id || '');
  if (value.length <= 14) return `+${value}`;
  return `+${value.slice(0, 7)}…${value.slice(-7)}`;
};

const MediaIdCopy = ({ id, compact = false, className = '' }) => {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);
  const shortcode = useMemo(() => `+${String(id || '')}`, [id]);

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  const handleCopy = useCallback(async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (!id) return;

    try {
      await navigator.clipboard.writeText(shortcode);
      setCopied(true);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopied(false), 1600);
    } catch (_err) {
      setCopied(false);
    }
  }, [id, shortcode]);

  if (!id) return null;

  return (
    <a
      href={`#media-id-${id}`}
      className={`paxsudos-media-id-link${compact ? ' paxsudos-media-id-link--compact' : ''}${className ? ` ${className}` : ''}`}
      onClick={handleCopy}
      title={copied ? `Kopioitu ${shortcode}` : `Kopioi media-ID ${shortcode}`}
    >
      {shortenId(id)}
    </a>
  );
};

export default MediaIdCopy;
